import React, { useState } from "react";
import { DefaultOutboundLink } from "./../../Miscellaneous/DefaultLink.component";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const EducationPart = (props) => {
  const [hovered, setHovered] = useState(false);

  return (
    <DefaultOutboundLink to={props.university_homepage || ""}>
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          transform: hovered ? "scale(1.05)" : "scale(1)",
        }}
      >
        <div
          className="mx-auto d-flex align-items-center justify-content-around"
          style={{
            maxWidth: "120px",
            marginBottom: "-1.25rem",
            zIndex: 40,
            position: "relative",
          }}
        >
          <Row
            className="text-white font-open-sans fw-b"
            style={{ width: "200px" }}
          >
            <Col
              xs={5}
              className="d-flex align-items-center justify-content-center"
              style={{
                minHeight: "2.5rem",
                background: "#EF3939",
                boxShadow: "inset -2px 0px 5px 1px rgba(0, 0, 0, 0.25)",
                borderRadius: "5px 0px 0px 5px",
              }}
            >
              {props.title}
            </Col>
            <Col
              xs={7}
              className="d-flex align-items-center justify-content-center"
              style={{
                minHeight: "2.5rem",
                background: "#C40000",
                boxShadow: "inset 0px 4px 4px rgba(0, 0, 0, 0.25)",
                borderRadius: "0px 5px 5px 0px",
              }}
            >
              {props.completion_month && `${props.completion_month}/`}
              {props.completion_year}
            </Col>
          </Row>
        </div>
        <Row
          style={{
            minHeight: "100px",
            zIndex: -1,
            transition: "0.1s ease-in-out",
            // transform: hovered ? 'scale(1.05)' : 'scale(1)',
            borderRadius: "5px",
            backgroundColor: "#F3F3F3",
          }}
        >
          <Col
            className="d-flex align-items-center justify-content-center"
            style={{
              background: "transparent",
              boxShadow: hovered ? "1px 2px 4px #CABBBB" : "none",
              borderRadius: "5px",
              minHeight: "140px",
              transition: "0.1s ease-in-out",
            }}
          >
            <div
              className="text-center d-flex align-items-center justify-content-center flex-column"
              style={{
                marginTop: "1.25rem",
                height: "auto",
              }}
            >
              <h3>
                {props.title} in {props.name}
              </h3>
              <h5 className="fw-n">
                <i>{props.university_name}</i>
              </h5>
              <h6 className="text-muted fw-l">
                {props.university_city && `${props.university_city}, `}
                {props.university_province && `${props.university_province}, `}
                {props.university_country && `${props.university_country} `}
                {props.university_postal_code}
              </h6>
            </div>
          </Col>
        </Row>
      </div>
    </DefaultOutboundLink>
  );
};

const Education = ({ cleanDegrees }) => {
  return (
    <div className="w-100 p-5">
      <div className="w-80 mx-auto p-2 mb-2 border-bottom text-center">
        <h3 className="font-open-sans fw-l">Education</h3>
      </div>
      <ul>
        {cleanDegrees.map((elem, idx) => (
          <li
            key={idx}
            style={{
              margin: "20px",
            }}
          >
            <EducationPart {...elem} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Education;
